/* Lemyn Coins — mockup layer (8 Oct 2026).
   Rules (Joe): 1 Coin per $1 spent · 100 Coins = $5 off · the balance turns into ONE voucher.
   In the mockup there is no sign-in, so a preview balance stands in (localStorage lemyn.coins.v1).
   On the live site the balance comes from the customer's Shopify record and the voucher is a real code. */
(function(){
var KEY='lemyn.coins.v1', PER=100, VAL=5;
function load(){ try{ var s=JSON.parse(localStorage.getItem(KEY)||'null'); if(s && typeof s.bal==='number') return s; }catch(e){} return {bal:340,use:false}; }
function save(s){ try{ localStorage.setItem(KEY, JSON.stringify(s)); }catch(e){} }
var ST=load();
window.LemynCoins = {
  balance:function(){ return ST.bal; },
  worth:function(n){ n=(n==null?ST.bal:n); return Math.floor(n/PER)*VAL; },
  earn:function(total){ return Math.floor(total||0); },
  using:function(){ return !!ST.use; },
  setUse:function(v){ ST.use=!!v; save(ST); paintAll(); },
  rules:'1 Lemyn Coin for every $1 spent; 100 Coins = $5 off; the whole balance turns into one voucher at checkout; Coins expire after 12 months without an order; wholesale accounts do not earn.'
};
var css=document.createElement('style');
css.textContent='.lc-coins{margin:12px 0 0;padding:12px 14px;border-radius:14px;background:#FFF6E2;border:1px solid #F1DDAE;font-size:14px;line-height:1.4;color:#191713}'
+'.lc-coins b{font-weight:800}.lc-coins .c1{display:flex;align-items:center;gap:8px}'
+'.lc-coins .dot{width:22px;height:22px;flex:none;border-radius:50%;background:radial-gradient(circle at 35% 30%,#FFE58A,#F2B807 60%,#C98F00);box-shadow:inset 0 -2px 0 rgba(0,0,0,.12);display:grid;place-items:center;font:800 11px/1 system-ui;color:#7a5600}'
+'.lc-coins .c2{display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between;gap:8px;margin-top:8px;padding-top:8px;border-top:1px dashed #E9CF94}'
+'.lc-coins button{border:0;border-radius:999px;padding:8px 14px;font:800 13px/1 inherit;font-family:inherit;cursor:pointer;background:#191713;color:#fff}'
+'.lc-coins button.on{background:#fff;color:#191713;box-shadow:inset 0 0 0 1.5px #191713}'
+'.lc-coins .pv{display:block;margin-top:6px;font-size:11px;color:#8a7f72;font-family:"IBM Plex Mono",Menlo,monospace;letter-spacing:.02em}'
+'.lc-coins .pay{font-weight:800}'
+'.lc-earn{display:flex;align-items:center;gap:6px;margin:6px 0 0;font-size:13px;font-weight:700;color:#9a6b00}.lc-earn .dot{width:16px;height:16px;flex:none;border-radius:50%;background:radial-gradient(circle at 35% 30%,#FFE58A,#F2B807 60%,#C98F00);display:grid;place-items:center;font:800 9px/1 system-ui;color:#7a5600}';
document.head.appendChild(css);
function money(n){ return '$'+n.toFixed(2); }
function parse(t){ var m=String(t||'').replace(/,/g,'').match(/\$\s*([0-9]+(?:\.[0-9]+)?)/); return m?parseFloat(m[1]):0; }
var targets=[];
function paint(t){
  var total=parse(t.el.textContent);
  var box=t.box;
  if(!total){ box.style.display='none'; return; }
  box.style.display='';
  var worth=window.LemynCoins.worth(), use=ST.use && worth>0;
  var off=use?Math.min(worth, Math.floor(total/VAL)*VAL):0;
  var earn=Math.floor(total-off);
  var h='<div class="c1"><span class="dot">L</span><span>This order earns <b>'+earn+' Lemyn Coins</b>.</span></div>';
  if(worth>0){
    h+='<div class="c2"><span>You have <b>'+ST.bal+' Coins</b> = '+money(worth)+(use?' &middot; <span class="pay">you pay '+money(total-off)+'</span>':'')+'</span>'
      +'<button type="button" class="'+(use?'on':'')+'">'+(use?'Keep my Coins':'Use '+money(worth)+' now')+'</button></div>';
  }
  h+='<span class="pv">Preview balance &middot; on lemyn.com your real Coins show after sign-in'+(use?' &middot; applied as one code at checkout':'')+'</span>';
  box.innerHTML=h;
  var b=box.querySelector('button'); if(b) b.onclick=function(){ window.LemynCoins.setUse(!ST.use); };
}
function paintAll(){ targets.forEach(paint); }
function hook(id){
  var el=document.getElementById(id); if(!el) return;
  var box=document.createElement('div'); box.className='lc-coins';
  /* insert directly after the totals row */
  var row=el.parentNode.parentNode; row.parentNode.insertBefore(box, row.nextSibling);
  var t={el:el,box:box}; targets.push(t);
  new MutationObserver(function(){ paint(t); }).observe(el,{childList:true,characterData:true,subtree:true});
  paint(t);
}
/* the small line under a price: "Earn 68 Lemyn Coins" */
function hookEarn(id){
  var el=document.getElementById(id); if(!el) return;
  var host=(id==='pBig')?el.parentNode:el;
  var e=document.createElement('div'); e.className='lc-earn';
  host.parentNode.insertBefore(e, host.nextSibling);
  var draw=function(){ var v=parse(el.textContent); if(!v){ e.style.display='none'; return; } var n=Math.floor(v); e.style.display=''; e.innerHTML='<span class="dot">L</span>Earn '+n+' Lemyn Coins'; };
  new MutationObserver(draw).observe(el,{childList:true,characterData:true,subtree:true}); draw();
}
function mount(){ ['bTotal','tot'].forEach(hook); ['rPrice','pBig'].forEach(hookEarn); }
if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',mount); else mount();
window.addEventListener('storage',function(e){ if(e.key===KEY){ ST=load(); paintAll(); } });
})();
